import Vue from 'vue'
import Vuex from 'vuex'
import layout from './modules/layout.js'
import auth from './modules/auth.js'
import noti from './modules/noti.js'
import _class from './modules/class.js'
import lecture from './modules/lecture.js'
import subject from './modules/subject.js'
import home_data from './modules/home_data.js'
import exam from './modules/exam.js'
import your_exam from './modules/your_exam.js'
import nihom_type from './modules/nihom_type.js'
import nihom_sub_type from './modules/nihom_sub_type.js'
import nihom_content from './modules/nihom_content.js'
import exercise from './modules/exercise.js'


Vue.use(Vuex)

export const store = new Vuex.Store({

  modules: {
    layout: layout,
    auth: auth,
    noti: noti,
    class: _class,
    lecture: lecture,
    subject: subject,
    home_data:home_data,
    exam:exam,
    your_exam:your_exam,
    nihom_type:nihom_type,
    nihom_sub_type:nihom_sub_type,
    nihom_content:nihom_content,
    exercise:exercise,
  }
})
